module.exports = __webpack_public_path__ + "assets/images/editor-icon-948a4375549461ebbcf98bdc2cad9e97.png";